import * as React from "react"
import type { SVGProps } from "react"
const SvgColdSubscriber = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M2.5 17.2v.8q0 .83.59 1.41.59.6 1.41.59h6q.42 0 .71-.29a1 1 0 0 0 .29-.71 1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29h-6v-.8a1 1 0 0 1 .5-.85q.9-.45 2.33-.9 1.42-.45 3.2-.45a1 1 0 0 0 .68-.28 1 1 0 0 0 .29-.67q0-.48-.29-.76a1 1 0 0 0-.68-.29q-1.7 0-3.32.4a15 15 0 0 0-3.11 1.15q-.76.38-1.17 1.1-.43.72-.43 1.55" />
    <path
      fillRule="evenodd"
      d="M7.68 10.83Q8.84 12 10.5 12c1.65 0 2.04-.4 2.83-1.17Q14.5 9.65 14.5 8c0-1.65-.4-2.04-1.17-2.82Q12.15 4 10.5 4c-1.65 0-2.04.4-2.82 1.18Q6.5 6.35 6.5 8c0 1.65.4 2.04 1.18 2.83M11.9 9.4a2 2 0 0 1-1.41.59q-.82 0-1.41-.59A2 2 0 0 1 8.5 8q0-.82.59-1.41A2 2 0 0 1 10.5 6q.83 0 1.41.59.6.59.59 1.41c-.01.82-.2 1.02-.59 1.41"
    />
    <path d="M17.5 10.17a.83.83 0 0 1 .83.83v1l.58-.59a.83.83 0 0 1 1.18 1.18l-1.76 1.75v.83h.83l1.75-1.76a.83.83 0 0 1 1.18 1.18l-.59.58h1a.83.83 0 1 1 0 1.66h-1l.59.58a.83.83 0 1 1-1.18 1.18l-1.75-1.76h-.83v.83l1.76 1.75a.83.83 0 1 1-1.18 1.18l-.58-.59v1a.83.83 0 1 1-1.66 0v-1l-.58.59a.83.83 0 0 1-1.18-1.18l1.76-1.75v-.83h-.83l-1.75 1.76a.83.83 0 0 1-1.18-1.18l.59-.58h-1a.83.83 0 1 1 0-1.66h1l-.59-.58a.83.83 0 0 1 1.18-1.18l1.75 1.76h.83v-.83l-1.76-1.75a.83.83 0 0 1 1.18-1.18l.58.59v-1a.83.83 0 0 1 .83-.83" />
  </svg>
)
export default SvgColdSubscriber
